// extracted by mini-css-extract-plugin
export default {"textarea":"PropertyAiGrade_textarea__1BZej","button":"PropertyAiGrade_button__3vyj4","fullResultBox":"PropertyAiGrade_fullResultBox__ob6lA"};